var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "user-details-block"
        }, [_c('div', {
          staticClass: "mt-5 pt-4 pull-right"
        }, [_c('b-dropdown', {
          attrs: {
            "size": "sm",
            "text": "Small",
            "variant": "light",
            "right": ""
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-ellipsis-h"
        })]), _c('b-dropdown-item', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.fetchFleetDetail(_vm.fleetData.id);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Edit")]), _c('b-dropdown-item', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.onDeleteFleet(_vm.fleetData);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v(" Delete")])], 2)], 1), _c('div', {
          staticClass: "user-profile text-center"
        }, [_vm.fleetData.img !== null || _vm.fleetData.img !== 'null' || _vm.fleetData.img !== 'undefined' ? _c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": _vm.fleetData.vehicleType.icon.url,
            "alt": ""
          }
        }) : _c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": _vm.fleetData.img,
            "alt": ""
          }
        })]), _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.fleetData.name))])]), _c('p', [_vm._v(_vm._s(_vm.fleetData.company.company))])]), _c('ul', {
          staticClass: "doctoe-sedual d-flex align-items-center justify-content-between p-0 mt-4 mb-0"
        }, [_c('li', {
          staticClass: "text-center"
        }, [_c('h6', {
          staticClass: "text-primary"
        }, [_vm._v("Year & Build")]), _c('h5', [_vm.fleetData.yearBuildCountry === null || _vm.fleetData.yearBuildCountry === 'null' || _vm.fleetData.yearBuildCountry === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.yearBuildCountry))]], 2)]), _c('li', {
          staticClass: "text-center"
        }, [_c('h6', {
          staticClass: "text-primary"
        }, [_vm._v("Flag")]), _c('h5', [_vm.fleetData.flag === null || _vm.fleetData.flag === 'null' || _vm.fleetData.flag === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.flag))]], 2)]), _c('li', {
          staticClass: "text-center"
        }, [_c('h6', {
          staticClass: "text-primary"
        }, [_vm._v("Complete Date")]), _c('h5', [_vm.fleetData.deliveryDate === null || _vm.fleetData.deliveryDate === 'null' || _vm.fleetData.deliveryDate === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.deliveryDate))]], 2)])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('nav', {
          attrs: {
            "aria-label": "breadcrumb "
          }
        }, [_c('ol', {
          staticClass: "breadcrumb bg-primary"
        }, [_c('li', {
          staticClass: "breadcrumb-item active text-white",
          attrs: {
            "aria-current": "page"
          }
        }, [_vm._v("Support Document")])])]), _c('ol', {
          attrs: {
            "type": "numbered"
          }
        }, [_vm._l(_vm.fleetData.docs, function (doc, index) {
          return [_c('li', {
            key: index
          }, [_vm._v(_vm._s(doc.iconName) + " "), _c('span', {
            staticClass: "pull-right"
          }, [_c('router-link', {
            attrs: {
              "to": doc.url
            }
          }, [_c('i', {
            staticClass: "fa fa-download"
          }), _vm._v(" Download File")])], 1)])];
        })], 2)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-borderless table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v("Code")]), _c('td', {
          attrs: {
            "width": "65%"
          }
        }, [_c('strong', [_vm.fleetData.code === null || _vm.fleetData.code === 'null' || _vm.fleetData.code === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.code))]], 2)])]), _c('tr', [_c('td', [_vm._v("Ownership")]), _c('td', [_c('strong', [_vm.fleetData.ownership === null || _vm.fleetData.ownership === 'null' || _vm.fleetData.ownership === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.ownership))]], 2)])]), _c('tr', [_c('td', [_vm._v("Technical Module")]), _c('td', [_c('strong', [_vm.fleetData.technical === true ? [_vm._v("Yes")] : [_vm._v("No")]], 2)])]), _c('tr', [_c('td', [_vm._v("ID GPS")]), _c('td', [_c('strong', [_vm.fleetData.idGps === null || _vm.fleetData.idGps === 'null' || _vm.fleetData.idGps === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.idGps))]], 2)])]), _c('tr', [_c('td', [_vm._v("Classification")]), _c('td', [_c('strong', [_vm.fleetData.classification === null || _vm.fleetData.classification === 'null' || _vm.fleetData.classification === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.classification))]], 2)])]), _c('tr', [_c('td', [_vm._v("Basic Function")]), _c('td', [_c('strong', [_vm.fleetData.basicFunction === null || _vm.fleetData.basicFunction === 'null' || _vm.fleetData.basicFunction === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.basicFunction))]], 2)])])])])])]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('nav', {
          attrs: {
            "aria-label": "breadcrumb "
          }
        }, [_c('ol', {
          staticClass: "breadcrumb bg-primary"
        }, [_c('li', {
          staticClass: "breadcrumb-item active text-white",
          attrs: {
            "aria-current": "page"
          }
        }, [_vm._v("Dimension")])])]), _c('table', {
          staticClass: "table mb-2 table-borderless table-box-shadow"
        }, [_c('thead', [_c('tr', [_c('th', {
          attrs: {
            "width": "50%"
          }
        }, [_vm._v("Dimensions")]), _c('th', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("Feet")]), _c('th', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("Meters")])])]), _c('tbody', [_c('tr', [_c('td', [_c('h5', [_vm._v("Length")])]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.length.feet))]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.length.meter))])]), _c('tr', [_c('td', [_c('h5', [_vm._v("Width")])]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.width.feet))]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.width.meter))])]), _c('tr', [_c('td', [_c('h5', [_vm._v("Depth")])]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.depth.feet))]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.depth.meter))])]), _c('tr', [_c('td', [_c('h5', [_vm._v("Draft")])]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.draft.feet))]), _c('td', [_vm._v(_vm._s(_vm.fleetData.dimension.draft.meter))])]), _c('tr', [_c('td', [_c('h5', [_vm._v("Speed")])]), _c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm.fleetData.dimension.speed === null || _vm.fleetData.dimension.speed === 'null' || _vm.fleetData.dimension.speed === 'undefined' ? [_vm._v("-")] : [_vm._v(_vm._s(_vm.fleetData.dimension.speed))]], 2)])])])]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('nav', {
          attrs: {
            "aria-label": "breadcrumb "
          }
        }, [_c('ol', {
          staticClass: "breadcrumb bg-primary"
        }, [_c('li', {
          staticClass: "breadcrumb-item active text-white",
          attrs: {
            "aria-current": "page"
          }
        }, [_vm._v("POWER")])])]), _c('ol', {
          attrs: {
            "type": "numbered"
          }
        }, [_vm._l(_vm.fleetData.powers, function (pwr, index) {
          return [_c('li', {
            key: index
          }, [_vm._v(_vm._s(pwr.powerType.name) + " - " + _vm._s(pwr.powerSeries.name) + " "), _c('small', [_vm._v(_vm._s(pwr.powerSeries.model))]), _c('span', {
            staticClass: "pull-right"
          }, [_vm._v("Actual RH: "), _c('strong', [_vm._v(_vm._s(pwr.actualRunningHours) + " RH")])])])];
        })], 2)]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('nav', {
          attrs: {
            "aria-label": "breadcrumb "
          }
        }, [_c('ol', {
          staticClass: "breadcrumb bg-primary"
        }, [_c('li', {
          staticClass: "breadcrumb-item active text-white",
          attrs: {
            "aria-current": "page"
          }
        }, [_vm._v("ROB Type")])])]), _c('ol', {
          attrs: {
            "type": "numbered"
          }
        }, [_vm._l(_vm.fleetData.robs, function (pwr, index) {
          return [_c('li', {
            key: index
          }, [_vm._v(_vm._s(pwr.robType.name) + " - " + _vm._s(pwr.robSeries.name) + " "), _c('span', {
            staticClass: "pull-right"
          }, [_vm._v("Current ROB: "), _c('strong', [_vm._v(_vm._s(pwr.actualRob) + " RH")])])])];
        })], 2)])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "3"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: "/ops/certificate",
        query: {
          vehicleId: _vm.vehicleId
        }
      }
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between"
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('h5', {
          staticClass: "card-title mb-2 mt-2 text-primary"
        }, [_c('strong', [_vm._v("TOTAL CERTIFICATE")])]), _c('h3', {
          staticClass: "mb-0 line-height"
        }, [_vm._v(_vm._s(_vm.statsCertificateData.totalCertificate !== null ? _vm.statsCertificateData.totalCertificate : '-'))])]), _c('div', {
          staticClass: "rounded-circle iq-card-icon bg-primary"
        }, [_c('i', {
          staticClass: "las la-certificate"
        })])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "3"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/ops/certificate"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between"
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('h5', {
          staticClass: "card-title mb-2 mt-2 text-primary"
        }, [_c('strong', [_vm._v("EXPIRED")])]), _c('h3', {
          staticClass: "mb-0 line-height"
        }, [_vm._v(_vm._s(_vm.statsCertificateData.totalExpired !== null ? _vm.statsCertificateData.totalExpired : '-'))])]), _c('div', {
          staticClass: "rounded-circle iq-card-icon bg-danger"
        }, [_c('i', {
          staticClass: "las la-exclamation"
        })])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "3"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/ops/certificate"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card iq-card-block iq-card-stretch"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between"
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('h5', {
          staticClass: "card-title mb-2 mt-2 text-primary"
        }, [_c('strong', [_vm._v("1 BULAN AKAN EXPIRED")])]), _c('h3', {
          staticClass: "mb-0 line-height"
        }, [_vm._v(_vm._s(_vm.statsCertificateData.totalOneMonth !== null ? _vm.statsCertificateData.totalOneMonth : '-'))])]), _c('div', {
          staticClass: "rounded-circle iq-card-icon bg-warning"
        }, [_c('i', {
          staticClass: "las la-tasks"
        })])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "3"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between"
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('h5', {
          staticClass: "card-title mb-2 mt-2 text-primary"
        }, [_c('strong', [_vm._v("PROGRESS")])]), _c('h3', {
          staticClass: "mb-0 line-height"
        }, [_vm._v(_vm._s(_vm.statsCertificateData.totalProcess !== null ? _vm.statsCertificateData.totalProcess : '-'))])]), _c('div', {
          staticClass: "rounded-circle iq-card-icon bg-success"
        }, [_c('i', {
          staticClass: "fa fa-clock-o"
        })])])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('tab-nav', {
          attrs: {
            "tabs": true
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "href": "#operational",
            "title": "Operational"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "href": "#certificate",
            "title": "Certificate"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "href": "#maintenance-board",
            "title": "Maintenance Board"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "href": "#maintenance-init",
            "title": "Maintenance Init"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "href": "#list-initial",
            "title": "Accident"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "href": "#recommendation",
            "title": "Recommendation"
          }
        })], 1), _c('div', {
          staticClass: "tab-content",
          attrs: {
            "id": "myTabContent"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "operational"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('iq-card', {
          attrs: {
            "body-class": "pb-0"
          },
          scopedSlots: _vm._u([{
            key: "body",
            fn: function fn() {
              return [_c('b-row', [_c('b-col', {
                attrs: {
                  "md": "8",
                  "lg": "8"
                }
              }, [_c('div', {
                staticStyle: {
                  "height": "100%",
                  "width": "100%",
                  "position": "relative",
                  "margin-left": "-30px",
                  "z-index": "9999"
                }
              }, [_c('l-map', {
                staticStyle: {
                  "width": "100%",
                  "height": "100%"
                },
                attrs: {
                  "zoom": _vm.zoom,
                  "center": _vm.center,
                  "options": _vm.mapOptions
                },
                on: {
                  "update:center": _vm.centerUpdate,
                  "update:zoom": _vm.zoomUpdate
                }
              }, [_c('l-tile-layer', {
                attrs: {
                  "url": _vm.url,
                  "attribution": _vm.attribution
                }
              }), _c('l-marker', {
                attrs: {
                  "lat-lng": _vm.getLatLng(_vm.fleetData.latitude, _vm.fleetData.longitude)
                }
              }, [_c('l-icon', {
                attrs: {
                  "icon-size": _vm.iconSize,
                  "icon-anchor": _vm.iconAnchor
                }
              }, [_c('img', {
                staticStyle: {
                  "width": "72px"
                },
                attrs: {
                  "src": _vm.getIcon(_vm.fleetData.vehicleType.icon)
                }
              })]), _c('l-tooltip', {
                attrs: {
                  "options": {
                    permanent: false,
                    interactive: true
                  }
                }
              }, [_vm._v(_vm._s(_vm.fleetData.name))])], 1), _c('l-control-zoom', {
                attrs: {
                  "position": "bottomleft"
                }
              })], 1)], 1)]), _c('b-col', {
                attrs: {
                  "md": "4",
                  "lg": "4"
                }
              }, [_c('iq-card', {
                attrs: {
                  "class-name": "iq-card-block iq-card-stretch iq-cad-height"
                },
                scopedSlots: _vm._u([{
                  key: "headerTitle",
                  fn: function fn() {
                    return [_c('h4', {
                      staticClass: "card-title"
                    }, [_vm._v("Last Operational")])];
                  },
                  proxy: true
                }, {
                  key: "body",
                  fn: function fn() {
                    return [_c('ul', {
                      staticClass: "iq-timeline m-0 p-0",
                      staticStyle: {
                        "height": "340px"
                      }
                    }, _vm._l(_vm.activityList, function (each) {
                      return _c('li', {
                        key: each.id
                      }, [_c('b-row', {
                        staticClass: "m-0"
                      }, [_c('b-col', {
                        attrs: {
                          "md": "12"
                        }
                      }, [_c('div', {
                        staticClass: "timeline-dots-fill"
                      }), _c('h6', {
                        staticClass: "float-left mb-2 text-dark"
                      }, [_c('i', {
                        staticClass: "ri-time-fill"
                      }), _vm._v(" " + _vm._s(each.startDate + ' - ' + each.endDate))]), _c('div', {
                        staticClass: "d-inline-block w-100"
                      }, [_c('b-badge', {
                        attrs: {
                          "variant": "info"
                        }
                      }, [_vm._v(_vm._s(each.activityDurationFormat))]), _c('p', [_vm._v(_vm._s(each.activityName))])], 1)])], 1)], 1);
                    }), 0)];
                  },
                  proxy: true
                }])
              })], 1)], 1), _c('hr'), _vm.vehicleId ? _c('b-row', {
                staticClass: "mt-5"
              }, [_c('b-col', {
                attrs: {
                  "md": "12"
                }
              }, [_c('Operational', {
                attrs: {
                  "isChildComponent": true
                }
              })], 1)], 1) : _vm._e()];
            },
            proxy: true
          }])
        })], 1)], 1)], 1), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "certificate"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('Certificate', {
          attrs: {
            "isChildComponent": true
          }
        })], 1)], 1)], 1), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "maintenance-board"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('MaintenanceSummaryBoard')], 1)], 1)], 1), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "maintenance-init"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('MaintenanceSummaryInit')], 1)], 1)], 1), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "list-initial"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('ListInitialTable', {
          attrs: {
            "vehicle-id": _vm.vehicleId
          }
        })], 1)], 1)], 1), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "recommendation"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('ListInitialRecommendation', {
          attrs: {
            "vehicle-id": _vm.vehicleId
          }
        })], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "edit-fleet",
      "size": "xl",
      "no-close-on-backdrop": true,
      "header-bg-variant": _vm.modal.headerBgVariant,
      "header-text-variant": _vm.modal.headerTextVariant,
      "body-bg-variant": _vm.modal.bodyBgVariant,
      "body-text-variant": _vm.modal.bodyTextVariant,
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', [_vm._v("Edit Your Fleet")]), _c('b-button', {
          attrs: {
            "size": "md",
            "variant": "outline-danger"
          },
          on: {
            "click": close
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        }), _vm._v(" Close ")])];
      }
    }])
  }, [_c('AddFleet', {
    attrs: {
      "formData": _vm.fleetDetail
    },
    on: {
      "childAction": function childAction($event) {
        return _vm.$bvModal.hide('edit-fleet');
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }